module.exports = __webpack_public_path__ + "static/gallery-11@2x-7026738e5500adff4f1379346ca21994.jpg";